module.exports = __webpack_public_path__ + "Roboto-BoldItalic.d23d5bdadc495f12ef69.ttf";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BoldItalic.ttf
// module chunks = 5